exports.achievements = [
   {
    type: "Award",
    year: "2025",
    title: "ISSR Graduate Poster Contest",
    subtitle: "Second Place in Proposed Research Category",
    description:
      "Won second place for proposed research on heat-aware route planning and outdoor mobility.",
    tags: ["Poster Contest", "Second Place", "$1000"],
    icon: "🏆",
  },
  {
    type: "Grant",
    year: "2025",
    title: "CAP LTER Graduate Student Grant",
    subtitle: "Outdoor Heat Exposure: Assessing Thermal Walkability in Three PASS Neighborhoods",
    description:
      "Received funding to study pedestrian thermal comfort in Phoenix-area neighborhoods.",
    tags: ["Research Grant", "CAP LTER", "$5000"],
    icon: "💰",
  },
  {
    type: "Award",
    year: "2025",
    title: "Outstanding Research Award",
    subtitle: "Graduate Student Government (GSG), ASU",
    description:
      "Recognized for ongoing research on weather-induced accessibility issues for blind and visually impaired pedestrians.",
    tags: ["Research Award"],
    icon: "🏆"
  },
  {
    type: "Travel Support",
    year: "2025–26",
    title: "Travel Grants",
    subtitle: "SCAI Travel Grant and Graduate College Travel Grant",
    description:
      "Received travel support for academic conference participation.",
    tags: [],
    icon: "✈️",
  },
];

exports.news_coverage = [
  {
    title: "New 'Cool Routes' app maps shadiest routes for your walk",
    subtitle: "With real-time weather and shade data, the online tool can reduce heat exposure without adding significant distance to a trip.",
    newspaper_name: "ASU News",
    url: "https://news.asu.edu/20260610-environment-and-sustainability-new-cool-routes-app-maps-shadiest-routes-your-walk?utm_campaign=ASU_News_News+6-17-26_7081195&utm_medium=email&utm_source=Media%20Relations%20&%20Strategic%20Communications_SFMCE&utm_term=ASU&utm_content=Shade-routes-hed&ecd42=518002422&ecd73=367247361&ecd37=ASU%20Media%20Relations_All%20Employees&ecd43=6/17/2026",
    date: "June 10, 2026",
    author: "Joe Rojas-Burke"
  },
  {
    title: "Arizona students design app that calculates least-sweaty walking route",
    subtitle: "Cool Routes helps users find the coolest paths and reduce exposure to dangerous heat.",
    newspaper_name: "Popular Science",
    url: "https://www.popsci.com/technology/cool-routes-walking-app-arizona/",
    date: "June 12, 2026",
    author: "Margherita Bassi"
  },
  {
    title: "Desperate for shade on your walk? There’s (almost) an app for that",
    subtitle: "By mapping shade, a new online tool calculates the best way to stroll a city without overheating.",
    newspaper_name: "Grist",
    url: "https://grist.org/cities/desperate-for-shade-on-your-walk-theres-almost-an-app-for-that/",
    date: "June 18, 2026",
    author: "Matt Simon"
  },
  {
    title: "Cool Routes tool maps shadiest walking paths on ASU Tempe campus",
    subtitle: "Cool Routes, an online tool developed by The SHaDE Lab at Arizona State, guides users to the coolest paths to walk. David Caltabiano explains how it works.",
    newspaper_name: "ARIZONA'S FAMILY",
    url: "https://www.azfamily.com/2026/06/25/cool-routes-tool-maps-shadiest-walking-paths-asu-tempe-campus/",
    date: "June 25, 2026",
    author: "David Caltabiano"
  },
  {
    title: "Cool Routes app plots shady walks in arid Arizona",
    subtitle: "Alternate routes provided by the app reduced the heat experienced during the walk by an average of 4.5 degrees.",
    newspaper_name: "Planetizen",
    url: "https://www.planetizen.com/news/2026/06/137813-cool-routes-app-plots-shady-walks-arid-arizona",
    date: "June 16, 2026",
    author: "Diana Ionescu"
  }
]